{
  "name": "Customer Master",
  "dbName": "customer_master",
  "columns": [
 
    {
      "fieldName": "name",
      "dbName": "name",
      "displayName": "Customer Name",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "200px"
      }
    },
    {
      "fieldName": "code",
      "dbName": "code",
      "displayName": "Customer Code",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "80px"
      },
      "styleConfig": {
        "type": "badge"
      }
    },
    {
      "fieldName": "active",
      "dbName": "active",
      "displayName": "Active",
      "dataType": "BOOLEAN",
      "valueMap": {
        "true": "Active",
        "false": "Inactive"
      },
      "thStyleConfig": {
        "width": "40px"
      },
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "customerType",
      "dbName": "customerType",
      "displayName": "Customer Type",
      "dataType": "ARRAY",
      "thStyleConfig": {
        "width": "300px"
      },
      "styleConfig": {
        "type": "multi-tag"

      }
    },
    

    {
      "fieldName": "modifiedAt",
      "dbName": "modified_date",
      "displayName": "Modified Date",
      "dataType": "DATETIME",
      "thStyleConfig": {
        "width": "80px"
      }
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "80px"
      },
      "styleConfig": {
        "type": "user-avatar"
      }
    }
  ],

  
    "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      },
            {
        "name": "CUSTOMER_TYPE_CONTAINS",
        "displayLabel": "Customer Type",
        "dataType": "DROPDOWN",
        "options":[],
        "operatorToFilterMap": {
          "EQ": "CUSTOMER_TYPE_CONTAINS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Customer by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "customer_name"
      }
    ]
  }
}
